var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { useLocation, useSearchParams } from 'react-router';
import { PaginationState, Paginator } from "../../../../Components/UI";
import { searchParamsFromSearchParams } from "../../../../../utils/routeHelpers";
import { PAGE_SIZE } from "../Loaders";

const PXTableFooter = ({
  total = 0,
  currentDataLength = 0



}) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { page: currentPage = 1 } = searchParamsFromSearchParams(searchParams);

  return (/*#__PURE__*/
    _jsx("div", { className: "flex items-center justify-between h-6" }, void 0, /*#__PURE__*/
    _jsx(PaginationState, {
      page: Number(searchParams.get('page') || 1),
      size: PAGE_SIZE,
      total: total,
      currentLength: currentDataLength }
    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Paginator, {
      totalPages: Math.ceil(total / PAGE_SIZE),
      currentPage: Number(currentPage),
      buildUrl: (page) => {
        const innerSearchParams = new URLSearchParams(location.search);
        innerSearchParams.delete('page');
        innerSearchParams.set('page', page);
        return `${location.pathname}?${innerSearchParams.toString()}`;
      } }
    )
    )
    ));

};

export { PXTableFooter };